<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>法规标准库</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
            infoText: `
             <h3><strong>正版合规、准确及时、可查可用的特种设备法规标准数据服务</strong></h3><p>“法规标准库”是特规通的核心基础模块，面向特种设备行业高频、刚需的规范查询、条款核验、标准引用和合规审查场景，提供可持续更新、可多维检索、可全文检索、可视化呈现、可在线阅读、可引用留痕的一体化法规标准服务。</p><p>特规通坚持以官方发布渠道、权威标准信息平台和正版发行合作渠道为数据来源，与行业专业发行服务机构合作建设正版法规标准资源体系，确保法规标准来源合规、版权清晰、信息可靠。平台通过持续更新、结构化处理、人工校对和效力状态维护，保障法规标准数据的准确性、及时性和可追溯性，帮助用户在工程技术、质量管理、许可评审、监督检查和日常学习中放心查、准确用、规范引。</p><p>法规标准库包含两个互补的资源库：特种设备行业库与全国标准库。前者聚焦特种设备专业场景，提供行业文件的深度使用能力；后者覆盖全国范围内多类型标准信息，支持跨行业、跨领域的标准检索与官方核验。</p><h3><strong>1）特种设备行业库：行业文件一站式获取与核验</strong></h3><p>特种设备行业库系统收录法律、法规、规章、安全技术规范、TSG、行政文件、国家标准、行业标准、技术图书等多类文件，累计 3000+ 份，覆盖锅炉、压力容器、压力管道、电梯、起重机械、客运索道、大型游乐设施、场内专用机动车辆等八大类特种设备，以及设计、制造、安装、改造、修理、检验检测、使用管理、维护保养等全流程场景。</p><p>用户可以在同一平台内完成从“找文件”到“看条文”，再到“做引用、留依据”的完整闭环，减少在多个网站、多个资料来源之间反复查找和核验的时间成本。</p><p>为保证内容的时效性与可用性，特规通持续跟踪官方发布渠道和权威标准信息来源，及时收录最新发布、修订、替代和废止的法规标准文件，并维护文件的实施状态与有效性信息，例如现行、即将实施、废止、被替代等，降低工程应用中“用错版本、引用失效、依据不清”的风险。</p><h3><strong>2）正版来源与数据质量：来源合规、版权清晰、内容可靠</strong></h3><p>法规标准是工程技术工作和企业合规管理的重要依据，来源是否正规、版本是否准确、内容是否可靠，直接影响技术判断和审核结论。特规通企业版将“正版合规、准确可靠”作为法规标准库建设的基础原则，重点保障以下能力：</p><ul><li><strong>正版合规来源</strong>：通过官方数据渠道、权威标准信息平台及正版发行合作渠道建设法规标准资源，保障文件来源规范、版权清晰、可核验。</li><li><strong>持续及时更新</strong>：持续跟踪法规标准发布、修订、替代、废止等动态，及时维护文件版本与实施状态。</li><li><strong>结构化精细处理</strong>：对法规标准正文、目录、条款、表格、图示、公式等内容进行结构化处理，提升检索、阅读和 AI 使用效果。</li><li><strong>人工审核校对</strong>：对关键元数据、文件状态、条款结构、引用关系等进行校对维护，提升数据准确性和可用性。</li><li><strong>可追溯可核验</strong>：保留文件来源、编号、名称、发布日期、实施日期、发布机构、效力状态等关键信息，方便用户进行合规核验和引用留痕。</li></ul>通过上述机制，特规通不仅提供“能查到”的法规标准资源，更提供“来源清楚、版本准确、状态明确、可以放心使用”的专业数据服务。<h3><strong>3）多维分类与检索：快速定位目标文件</strong></h3><p>面对特种设备法规标准体系“文件多、分类复杂、版本变更频繁”的现实，平台提供多种分类与检索方式，支持用户按文件编号、文件名称、文件类型、效力层级、发布机构、发布时间、实施时间、技术委员会、设备类别、业务环节等多维条件组合筛选。</p><p>无论用户要查找某一份具体标准，还是要梳理某个许可项目、某类设备、某个业务环节涉及的法规标准范围，都可以通过分类导航和条件检索快速定位目标文件，避免依赖个人经验反复翻找。</p><h3><strong>4）全文检索：在海量法规标准中快速找到关键信息</strong></h3><p>特规通将法规标准文件处理为结构化数据，支持对文件正文内容进行全文检索。用户不仅可以按文件名称和编号查标准，还可以直接检索法规标准内部的具体内容，让“在海量文件中找信息”变得简单、快速、精准。</p><p>在实际工作中，用户可以直接检索：</p><ul><li>材料牌号、材料名称、技术参数；</li><li>设备部件、结构名称、零部件术语；</li><li>专业术语、定义、适用范围；</li><li>公式、符号、计算参数；</li><li>检验项目、试验要求、判定规则；</li><li>质量控制要求、制造要求、安装要求；</li><li>许可条件、人员要求、设备要求、质量保证体系要求；</li><li>某一关键词在不同法规标准中的出现位置和上下文。</li></ul><p>全文检索特别适合工程技术人员在设计、制造、检验、审查、评审、培训和问题整改中快速查找依据。例如，查某个材料牌号适用于哪些标准，查某个部件在哪些条款中出现，查某个术语的定义来源，查某个公式或参数的适用条件，都可以通过全文检索快速定位到相关文件和具体条款，大幅提升资料查找和技术核验效率。</p><h3><strong>5）元数据可视化：一眼看懂文件“身份信息”</strong></h3><p>每份法规标准文件均收录完整元数据，并以清晰、可视化的方式呈现，帮助用户快速判断文件是否适用、是否现行、是否需要关注修订版本。平台提供文件简介、目录预览、发布日期、实施日期、发布机构、效力状态、替代关系等关键信息，让用户在打开文件前即可掌握文件基本情况。</p><p>依托标准法规数据中心能力，平台还系统化建立文件之间的关联网络，包括：</p><ul><li><strong>引用关系</strong>：哪些文件引用了它，它又引用了哪些文件；</li><li><strong>编制历史</strong>：文件制修订、换版、发布和实施的关键节点；</li><li><strong>替代关系</strong>：它替代了哪些文件，又被哪些文件替代；</li><li><strong>关联文件</strong>：与当前文件在设备类别、业务环节、技术主题上相关的法规标准。</li></ul><p>这类关系能力可帮助用户更高效地完成规范体系梳理、版本核验和合规审查，尤其适用于方案论证、设计审查、制造检验、质量体系建设、许可评审和培训学习等场景。</p><h3><strong>6）在线阅读：原文阅读 + 智能阅读，兼顾严谨与效率</strong></h3><p>特种设备行业库文件支持在线阅读，提供 PDF 阅读和智能阅读两种互补模式，兼顾原文严谨性与日常使用效率。</p><ul><li>PDF 阅读模式忠实呈现原文件版式，适用于核对原文、审查留痕、查看图表、引用原始页面等场景。平台提供结构化目录，支持快速跳转对应页码，让“翻页找条款”变成“点目录直达”。</li><li>智能阅读模式以结构化数据为基础，对文件内容进行清晰呈现和精细化定位。用户可以在文件内部进行全文检索，快速定位所需内容；可以复制条文内容；也可以使用智能引用能力，在引用时自动带出文件编号、文件名称及条款号，形成规范性引用格式，便于撰写报告、技术文件、制度文件和内部沟通材料。</li></ul><p>同时，平台支持笔记与学习辅助功能，帮助用户在学习标准、理解条款和日常工作中沉淀个人经验，形成可复用的专业知识积累。</p><h3><strong>7）全国标准库：覆盖更广的官方标准信息检索</strong></h3><p>除特种设备行业库外，特规通还提供全国标准库，收录全国范围内国家标准、行业标准、地方标准、团体标准、计量规范规程等 30 万+ 条标准文件数据，支持用户在工作中进行跨行业、跨领域标准检索与对照。</p><p>全国标准库中的文件信息来自官方标准信息平台，支持用户一键跳转至标准文件的官方原文页面，实现快速核验与权威查询。数据库保持持续更新，确保标准信息准确、全面、及时。</p><p>通过“特种设备行业库 + 全国标准库”的组合，用户既可以深度使用特种设备专业法规标准，也可以快速查询其他领域相关标准信息，满足跨专业、跨行业、跨项目的综合检索需求。</p><h3><strong>8）支撑企业合规管理与许可评审</strong></h3><p>对于特种设备生产、设计、制造、安装、检验检测和使用单位而言，法规标准库不仅是日常查询工具，也是企业合规管理和许可评审准备的重要基础。</p><p>企业可以依托法规标准库快速梳理本单位许可范围、产品范围、设备类别和业务流程所需的法规标准依据，核对标准版本和实施状态，建立适用于本企业的法规标准清单，并与企业资料馆、法规标准收藏书单、AI 问答等功能联动使用。</p><p>在许可评审、体系审核、监督检查、内部审查、人员培训和技术文件编制等场景中，法规标准库可以帮助企业更高效地完成依据查询、条款引用、版本核验和资料准备，提升合规管理的规范性和工作效率。</p><h3><strong>9）核心价值：让法规标准真正可信、好查、好用</strong></h3><p>特规通法规标准库的核心价值，不只是把法规标准集中展示出来，而是通过正版合规来源、权威数据渠道、持续更新机制、结构化处理能力、全文检索能力和 AI 应用接口，帮助用户建立稳定、可信、可追溯的法规标准使用体系。</p><p>它让用户能够：</p><ul><li>放心使用正版合规、来源清晰的法规标准资源；</li><li>快速掌握文件版本、效力状态和替代关系；</li><li>在海量法规标准中精准查找材料、部件、术语、公式和条款依据；</li><li>在线阅读原文并进行智能化条文定位和引用；</li><li>将法规标准与企业资料馆、书单管理和 AI 问答打通；</li><li>支撑企业许可评审、质量体系建设和日常合规管理。</li></ul><p>通过法规标准库，特规通为特种设备行业用户提供准确、及时、可靠、可持续使用的法规标准数据底座，让“查规范、用规范、管规范、审规范”更加高效、规范和可信。</p>
            `
        };
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);
	h3 {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
}
.info-item {
	margin-bottom: 20px;
}
.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;
	.topbox {
		color: #94a3b8;
		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
		color: #0f172a;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>